// @flow
const LOAD = 'google/LOAD';
const LOGIN = 'google/LOGIN';
const LOGOUT = 'google/LOGOUT';
const LOGGED_IN = 'google/LOGGED_IN';
const LOGIN_STATUS = 'google/LOGIN_STATUS';

type Action = {| type: typeof LOGIN |} | {| type: typeof LOGOUT |};

type Event = typeof LOGGED_IN;

export const actions: { [string]: (any) => Action } = {
  updateLoginStatus: () => ({ type: LOGIN_STATUS }),
  login: () => ({ type: LOGIN }),
  logout: () => ({ type: LOGOUT }),
  load: () => ({ type: LOAD })
};

export const events: { [string]: Event } = {
  LOGGED_IN
};

const types = [LOGIN, LOGOUT, LOGIN_STATUS, LOAD];

let loadGoog = () => {
  const promise = new Promise(resolve => {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/platform.js';
    script.async = true;
    script.defer = true;
    script.addEventListener('load', () => {
      window.gapi.load('auth2', () => {
        window.gapi.auth2.init({
          client_id: process.env.GOOGLE_CLIENT_ID
        });
        resolve();
      });
    });
    window.document.body.appendChild(script);
  });
  // Only load the script once ever
  loadGoog = () => promise;
  return promise;
};

export default (store: any) => (next: (...args: Array<any>) => any) => (
  action: Action
): any => {
  if (types.indexOf(action.type) === -1) {
    return next(action);
  }

  if (typeof window.gapi === 'undefined') {
    const load = loadGoog();
    return new Promise(resolve =>
      load.then(() => store.dispatch(action).then(resolve))
    );
  }

  switch (action.type) {
    case LOGIN_STATUS: {
      const auth2 = window.gapi.auth2.getAuthInstance();
      const authResponse = auth2.currentUser.get().getAuthResponse(true);
      return Promise.resolve(authResponse);
    }

    case LOGIN: {
      const auth2 = window.gapi.auth2.getAuthInstance();
      const promise = new Promise(resolve => {
        auth2.signIn().then(() => {
          store.dispatch({
            type: LOGGED_IN,
            payload: auth2.currentUser.get().getAuthResponse(true)
          });
          resolve(auth2.currentUser.get().getAuthResponse(true));
        });
      });
      return promise;
    }

    case LOGOUT: {
      return Promise.resolve();
    }

    case LOAD: {
      return Promise.resolve();
    }

    default: {
      return next(action);
    }
  }
};
